import { useState } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useMe } from '@/features/users/use-users'

const DISMISS_KEY = 'todone-first-login-banner-dismissed'

/**
 * Shown on the dashboard after the first OIDC login until the user dismisses it OR customizes
 * their profile. "Customized" is implied by displayName != handle (the JIT default sets them
 * equal when no `name` claim was present, and Keycloak emits `name` once first/last are set).
 */
export const FirstLoginBanner = () => {
  const { data: me } = useMe()
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && window.localStorage.getItem(DISMISS_KEY) === '1'
  )

  if (!me || dismissed) return null

  const dismiss = () => {
    window.localStorage.setItem(DISMISS_KEY, '1')
    setDismissed(true)
  }

  return (
    <Alert>
      <AlertTitle className="flex items-center justify-between gap-2">
        <span>Welcome to ToDoNE, @{me.handle}!</span>
        <Button variant="ghost" size="icon" className="h-6 w-6" onClick={dismiss}>
          <X className="h-4 w-4" />
        </Button>
      </AlertTitle>
      <AlertDescription>
        We picked your handle from your sign-in. Customize your handle, display name, and bio
        whenever — head to{' '}
        <Link to="/settings/profile" className="font-medium underline">
          settings/profile
        </Link>{' '}
        to make it yours.
      </AlertDescription>
    </Alert>
  )
}
